import React from 'react';
import styles from './Specials.module.css';

const specialItems = [
  { name: 'દહીં ગાંઠિયા', image: '/Special/s1.png' },
  { name: 'કાજુ લસણ', image: '/Special/s2.png' },
  { name: 'કાજુ કારેલા', image: '/Special/s3.jpg' },
  { name: 'મકાઈ મુઠિયા', image: '/Special/s4.png' },
  { name: 'મકાઈ મેથી', image: '/Special/s5.png' },
  { name: 'લીલા ચણાનું શાક', image: '/Special/s6.png' },
  { name: 'લસૂણી મેથી', image: '/Special/s7.png' },
  { name: 'મલાઈ દો પ્યાઝ', image: 'https://justdeliciousness.com/wp-content/uploads/2022/02/IMG_6192.jpg' },
  { name: 'ભરેલા પાપડ', image: '/Special/s8.png' },
  { name: 'કાજુ ગાંઠિયા', image: '/Special/s11.png' },
  { name: 'કાઠીયાવાડી વધારેલો રોટલો', image: '/Special/s10.png' }
];

const Specials = () => {
  const handleOrderClick = (itemName) => {
    const message = `નમસ્તે Janki's Cloud Kitchen,\n\nહું "${itemName}" ઓર્ડર કરવા માંગુ છું.\n\nકૃપા કરીને વધુ વિગતો આપો.\n\nઆભાર! 🙏`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/918183934567?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="specials" className={styles.specials}>
      <div className={styles.container}>
        <h2 className={styles.title}>અમારી અનોખી વેરાયટીનો સ્વાદોત્સવ</h2>
        <p className={styles.subtitle}>Our Special Varieties</p>
        
        <div className={styles.grid}>
          {specialItems.map((item, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.imageWrapper}>
                <img src={item.image} alt={item.name} className={styles.foodImage} />
              </div>
              <h3 className={styles.itemName}>{item.name}</h3>
              <button 
                className={styles.orderBtn}
                onClick={() => handleOrderClick(item.name)}
              >
              
                ઓર્ડર કરો
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specials;
